<!--suppress XmlHighlighting, XmlHighlighting -->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content artist-edit-page'>
        <el-form class='artist-edit-form' ref='artistForm' :model='formData' :rules='rules' label-position='top'>
          <div class='artist-edit-grid'>
            <section class='artist-edit-panel basic-panel'>
              <div class='panel-header'>
                <div class='panel-title'>
                  <strong>基本信息</strong>
                </div>
                <div class='panel-actions'>
                  <el-link type='primary' @click='handleLog'>操作记录</el-link>
                  <el-button type='primary' size='mini' v-if="userPermissions.indexOf('artist_edit') !== -1"
                             @click='saveConfirm'>保存
                  </el-button>
                </div>
              </div>
              <div class='panel-body'>
                <div class='basic-profile'>
                  <div class='avatar-wrap editable-avatar' @click='openAvatarEditor'
                       :title='`点击编辑 ${formData.nickname || ""} 的头像`'>
                    <el-avatar v-if='avatarSrc' :key='avatarSrc' :size='96' :src='avatarSrc'></el-avatar>
                    <el-avatar v-else :size='96' icon='el-icon-user-solid'></el-avatar>
                    <div class='avatar-edit-badge'>
                      <i class='el-icon-camera'></i> 编辑
                    </div>
                  </div>
                  <div class='profile-info'>
                    <div class='profile-title-row'>
                      <h2>{{ formData.nickname || '-' }}</h2>
                      <el-tag size='mini' effect='plain'>同步</el-tag>
                    </div>
                    <el-tag class='sign-status-pill' :class="formData.sign_status === 'Y' ? 'is-signed' : 'is-fired'"
                            size='small'>{{ formData.sign_status === 'Y' ? '已签约' : '已解约' }}
                    </el-tag>
                  </div>
                </div>
                <div>
                  <br/>
                  <span style="color: #909399"><b>同步信息</b> * 来自签约信息同步，不可编辑</span>
                  <div class='readonly-field'>
                    <span>红人昵称</span>
                    <strong>{{ formData.nickname || '-' }}</strong>
                  </div>
                  <!-- 签约时间、合约到期、红人备注 暂不展示（按需求先注释，恢复时取消注释即可）
                  <div class='readonly-field'>
                    <span>签约时间</span>
                    <strong>{{ formData.sign_start || '-' }}</strong>
                  </div>
                  <div class='readonly-field'>
                    <span>合约到期</span>
                    <strong>{{ formData.sign_end || '-' }}</strong>
                  </div>
                  <div class='readonly-field'>
                    <span>红人备注</span>
                    <strong>{{ formData.remark || '-' }}</strong>
                  </div>
                  -->
                </div>

                <p class='edit-section-title'>可编辑信息</p>
                <!-- 头像编辑：隐藏实例，由顶部头像点击唤起裁剪上传 -->
                <div style='display: none'>
                  <ArtistAvatar ref='refAvatarEditor' :img-url='avatarSrc' @uploaded='setArtistAvatar'/>
                </div>

                <el-form-item label='肤质' prop='skin_type'>
                  <el-input v-model='formData.skin_type' maxlength='50' :show-word-limit='true'
                            :clearable='true' />
                </el-form-item>
                <el-form-item label='标签' prop='kol_label'>
                  <el-input v-model='formData.kol_label' maxlength='100' :show-word-limit='true'
                            :clearable='true' />
                </el-form-item>
                <el-form-item label='直播类型' prop='live_type'>
                  <el-radio-group v-model='formData.live_type'>
                    <el-radio :label='liveTypeOption.value'
                              v-for='liveTypeOption in liveTypeOptions' :key='liveTypeOption.value'>
                      {{ liveTypeOption.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </section>

            <section class='artist-edit-panel data-panel'>
              <div class='panel-header'>
                <div class='panel-title'>
                  <strong>数据平台信息</strong>
                  <span>点击平台展开</span>
                </div>
                <el-button type='primary' size='mini' v-if="userPermissions.indexOf('artist_edit') !== -1"
                           @click='saveConfirm'>保存
                </el-button>
              </div>
              <div class='panel-body platform-list'>
                <div class='data-platform-card' v-for='item in platformsData' :key='item.code'>
                  <div class='data-platform-head' @click='togglePlatform(item.code)'>
                    <div class='platform-name'>
                      <el-image class='platform-icon' :src='item.logo_url' fit='contain'></el-image>
                      <strong>{{ item.name }}</strong>
                      <span>{{ getPlatformAccountCount(item.code) }}个账号</span>
                    </div>
                    <div class='platform-controls' @click.stop>
                      <el-tag class='platform-state-tag'
                              :class="formData.platforms[item.code] === 'Y' ? 'is-opened' : 'is-closed'"
                              size='mini'>{{ formData.platforms[item.code] === 'Y' ? '已开通' : '未开通' }}
                      </el-tag>
                      <el-switch v-model='formData.platforms[item.code]' active-value='Y' inactive-value='N'
                                 active-color='#ff3176' inactive-color='#cfd4dc'
                                 @change='handlePlatformSwitch(item.code)'></el-switch>
                      <i class='platform-arrow'
                         :class="platformExpanded[item.code] ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                         @click='togglePlatform(item.code)'></i>
                    </div>
                  </div>
                  <div class='account-editor' v-show='platformExpanded[item.code]'>
                    <div class='account-row' v-for='index in getPlatformAccountRows(item.code)'
                         :key='item.code + index'>
                      <el-form-item label='平台ID'
                                    :required="formData.platforms[item.code] === 'Y'">
                        <el-input v-model='formData.platforms_account_id[item.code][index - 1]' size='mini' />
                      </el-form-item>
                      <el-form-item label='UID'>
                        <el-input v-model='formData.platforms_uid[item.code][index - 1]' size='mini' />
                      </el-form-item>
                      <el-button class='remove-account' type='text' icon='el-icon-close'
                                 @click='removePlatformAccount(item.code,index - 1)'></el-button>
                    </div>
                    <button class='add-account-button' type='button' @click='addPlatformAccount(item.code)'>
                      + 添加账号
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class='artist-edit-panel journal-panel'>
              <div class='panel-header'>
                <div class='panel-title'>
                  <strong>刊例平台信息</strong>
                  <span>{{ kolPlatform.length }}个平台</span>
                </div>
                <div class='panel-actions'>
                  <el-button type='text' icon='el-icon-refresh' :loading='syncLoading' @click='syncBasicInfo'>同步基本信息</el-button>
                  <el-button type='primary' size='mini' @click='showKolPlatformInfo()'>添加</el-button>
                </div>
              </div>
              <div class='panel-body journal-list'>
                <div class='journal-card' v-for='item in kolPlatform' :key='item.id'>
                  <div class='journal-card-top'>
                    <div class='journal-platform-name'>
                      <el-image class='platform-icon' :src='item.platform_logo_url' fit='contain'></el-image>
                      <strong>{{ item.platform_name }}</strong>
                    </div>
                    <el-image class='journal-avatar' :src='item.cover_url || formData.avatar' fit='cover'></el-image>
                  </div>
                  <div class='journal-info-line'>
                    <span>平台ID：</span>{{ item.account_id || '-' }}
                  </div>
                  <div class='journal-info-line'>
                    <span>经纪人：</span>{{ item.agent_name || '-' }}
                  </div>
                  <div class='journal-info-line'>
                    <span>城市：</span>{{ item.city || '-' }}
                  </div>
                  <div class='journal-info-line'>
                    <span>昵称：</span>{{ item.nickname || '-' }}
                  </div>
                  <!--                  <div class='journal-info-line'>-->
                  <!--                    <span>IP归属：</span>{{ item.ip_location || '-' }}-->
                  <!--                  </div>-->
                  <div class='journal-info-line'>
                    <span>肤质：</span>{{ item.skin_type || '-' }}
                  </div>
                  <div class='journal-info-line'>
                    <span>标签：</span>{{ item.kol_label || '-' }}
                  </div>
                  <div class='journal-info-line'>
                    <span>直播类型：</span>{{ liveTypeName(item.live_type) }}
                  </div>
                  <div class='journal-info-line one-line'>
                    <span>主页链接：</span>{{ item.home_page_link || '-' }}
                  </div>
                  <div class='journal-info-line two-line'>
                    <span>简介：</span>{{ item.intro || '-' }}
                  </div>
                  <div class='journal-actions'>
                    <el-link type='primary' @click='showKolPlatformInfo(item)'>修改</el-link>
                    <el-link type='primary' @click='delItem(item)'>删除</el-link>
                  </div>
                </div>
                <el-empty v-if='kolPlatform.length === 0' description='暂无刊例平台'></el-empty>
              </div>
            </section>
          </div>
        </el-form>
      </div>
      <el-dialog
        width="50%"
        :visible.sync="LogdialogVisible"
      >
        <ArtistLog :artist-id='this.formData.id'/>

      </el-dialog>
      <el-dialog
        :title="`${editForm?.id?'修改':'增加'}刊例平台信息`"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <KolPlatformInfo @close="close" :platforms="platformsPlcData" ref='refKolPlatformInfo' :formData="editForm" :key="platformDialogKey"/>
      </el-dialog>
      <el-dialog title='同步基本信息' :visible.sync='syncDialogVisible' width='440px' class='sync-basic-dialog'>
        <div class='sync-basic-body'>
          <p class='sync-basic-desc'>
            将红人「<strong>{{ formData.nickname || '-' }}</strong>」的昵称、肤质、标签、直播类型同步到全部
            <strong>{{ kolPlatform.length }}</strong> 个刊例平台信息。
          </p>
          <div class='sync-basic-option'>
            <el-checkbox v-model='syncForceOverwrite' border class='sync-force-check'>
              强制覆盖已填写的字段
            </el-checkbox>
            <p class='sync-basic-mode' :class='syncForceOverwrite ? "is-overwrite" : "is-fill"'>
              <i class='el-icon-info' v-if='!syncForceOverwrite'></i>
              <i class='el-icon-warning' v-else></i>
              <span>{{ syncForceOverwrite ? '勾选后：将覆盖所有已填写的字段（含非空值）' : '默认：仅填充空字段，保留平台已填写的值' }}</span>
            </p>
          </div>
        </div>
        <div slot='footer'>
          <el-button size='mini' @click='syncDialogVisible = false'>取消</el-button>
          <el-button size='mini' type='primary' :loading='syncLoading' @click='confirmSyncBasic'>确定同步</el-button>
        </div>
      </el-dialog>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import {mapGetters} from 'vuex'
import KolPlatformInfo from '@/pages/artist/KolPlatformInfo'
import ArtistLog from '@/pages/artist/ArtistLog'
import ArtistAvatarCarousel from '@/pages/artist/components/ArtistAvatarCarousel.vue'
import ArtistAvatar from '@/pages/artist/ArtistAvatar'

const data = {
  artist_id: '',
  code: '',
  account_id: '',
  home_page_link: '',
  agent_name: '',
  city: '',
  intro: '',
  cover_url: null,
  nickname: '',
  ip_location: '',
  skin_type: '',
  kol_label: '',
  live_type: 1
}
export default {
  name: 'ArtistCreateEdit',
  components: {
    ArtistAvatar,
    ArtistAvatarCarousel,
    ArtistLog,
    KolPlatformInfo,
    PageHeaderLayout
  },
  data() {
    return {
      artistId: null, // 红人id，null表示创建，非null为编辑
      platforms: [],
      formData: {
        nickname: '',
        group_id: null,
        group_time: null,
        sign_status: 'Y',
        platforms: {},
        platforms_account_id: {},
        platforms_uid: {},
        sign_start: null,
        sign_end: null,
        fired_at: null,
        remark: '',
        avatar: '',
        skin_type: '',
        live_type: null,
        kol_label: ''
      },
      liveTypeOptions: [
        { value: 1, name: '达播' },
        { value: 2, name: '日播' }
      ],
      rules: {
        skin_type: [
          { required: true, message: '输入肤质必填', trigger: 'blur' }
        ],
        live_type: [{ required: true, message: '直播类型必选', trigger: 'blur' }],
        kol_label: [{ required: true, message: '标签必填', trigger: 'blur' }]
      },
      kolPlatform: [],
      dialogVisible: false,
      platformDialogKey: 0,
      platformExpanded: {},
      syncLoading: false,
      syncForceOverwrite: false,
      syncDialogVisible: false,
      editForm: {
        ...data
      },
      LogdialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    platformsData() {
      return this.platforms.filter(item => Number(item.is_data_entry) === 1)
    },
    platformsPlcData() {
      return this.platforms.filter(item => Number(item.is_plc_entry) === 1)
    },
    // 头像展示地址：优先 artists.avatar，回退到 ArtistJournal.cover_url
    avatarSrc() {
      return this.formData.avatar || this.formData.cover_url || ''
    }
  },
  created() {
    this.initForm()
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.getKolPlatform()
    },
    setArtistAvatar(val) {
      this.formData.avatar = (val && val.full_path) || ''
    },
    openAvatarEditor() {
      if (this.$refs.refAvatarEditor) {
        this.$refs.refAvatarEditor.editCropper()
      }
    },
    defaultPlatforms() {
      // 平台账号：默认有账号
      const platforms = {}
      this.platformsData.forEach((platform) => {
        platforms[platform.code] = 'N'
      })
      this.formData.platforms = platforms
    },
    defaultPlatformsId() {
      const platforms_account_id = {}
      this.platformsData.forEach((platform) => {
        platforms_account_id[platform.code] = []
      })

      // this.formData.platforms_account_id = platforms_account_id
      this.$set(this.formData, 'platforms_account_id', platforms_account_id)
    },
    defaultPlatformsUid() {
      const platforms_uid = {}
      this.platformsData.forEach((platform) => {
        platforms_uid[platform.code] = []
      })

      this.$set(this.formData, 'platforms_uid', platforms_uid)
    },
    async initForm() {
      //分组列表
      await this.getPlatforms()
      // 签约状态：默认签约
      this.formData.sign_status = 'Y'
      this.defaultPlatforms()
      this.defaultPlatformsId()
      this.defaultPlatformsUid()
      // 获取到ID：编辑
      if (this.$route.params.artist_id) {
        this.artistId = this.$route.params.artist_id
      }
      if (this.artistId) {
        await this.getArtistDetail()
        await this.getKolPlatform()
      }
      this.normalizeAllPlatformAccounts()
      this.initPlatformExpanded()

    },
    async getArtistDetail() {
      this.deleteVisible = false
      const { info } = await this.$api.getArtistInfo(this.artistId)
      this.formData = info
      if (!this.formData.platforms) {
        this.defaultPlatforms()
      } else {
        this.filterPlatforms()
      }
      if (!this.formData.platforms_account_id) {
        this.defaultPlatformsId()
      }
      if (!this.formData.platforms_uid) {
        this.defaultPlatformsUid()
      }
      this.normalizeAllPlatformAccounts()
    },
    filterPlatforms() {
      const newPlatforms = {}
      this.platformsData.forEach((platform) => {
        newPlatforms[platform.code] = this.formData.platforms[platform.code] || 'N'
      })
      this.formData.platforms = newPlatforms
    },
    normalizeAccountList(value) {
      if (Array.isArray(value)) {
        return value
      }
      if (value === null || typeof value === 'undefined' || value === '') {
        return []
      }
      return [value]
    },
    normalizeAllPlatformAccounts() {
      this.platformsData.forEach((platform) => {
        this.ensurePlatformAccountArrays(platform.code)
      })
    },
    ensurePlatformAccountArrays(code) {
      if (!this.formData.platforms_account_id) {
        this.$set(this.formData, 'platforms_account_id', {})
      }
      if (!this.formData.platforms_uid) {
        this.$set(this.formData, 'platforms_uid', {})
      }
      const rawIds = this.formData.platforms_account_id[code]
      const rawUids = this.formData.platforms_uid[code]
      const ids = this.normalizeAccountList(rawIds)
      const uids = this.normalizeAccountList(rawUids)
      let shouldUpdateIds = !Array.isArray(rawIds)
      let shouldUpdateUids = !Array.isArray(rawUids)
      const maxLength = Math.max(ids.length, uids.length)
      while (ids.length < maxLength) {
        ids.push('')
        shouldUpdateIds = true
      }
      while (uids.length < maxLength) {
        uids.push('')
        shouldUpdateUids = true
      }
      if (shouldUpdateIds) {
        this.$set(this.formData.platforms_account_id, code, ids)
      }
      if (shouldUpdateUids) {
        this.$set(this.formData.platforms_uid, code, uids)
      }
    },
    getPlatformAccountRows(code) {
      this.ensurePlatformAccountArrays(code)
      return Math.max(
        this.formData.platforms_account_id[code].length,
        this.formData.platforms_uid[code].length
      )
    },
    getPlatformAccountCount(code) {
      this.ensurePlatformAccountArrays(code)
      return this.formData.platforms_account_id[code].filter(item => item).length
    },
    addPlatformAccount(code) {
      this.ensurePlatformAccountArrays(code)
      this.formData.platforms_account_id[code].push('')
      this.formData.platforms_uid[code].push('')
      this.$set(this.platformExpanded, code, true)
    },
    removePlatformAccount(code, index) {
      this.ensurePlatformAccountArrays(code)
      this.formData.platforms_account_id[code].splice(index, 1)
      this.formData.platforms_uid[code].splice(index, 1)
    },
    togglePlatform(code) {
      this.$set(this.platformExpanded, code, !this.platformExpanded[code])
    },
    handlePlatformSwitch(code) {
      this.ensurePlatformAccountArrays(code)
      if (this.formData.platforms[code] === 'Y') {
        this.$set(this.platformExpanded, code, true)
        if (this.getPlatformAccountRows(code) === 0) {
          this.addPlatformAccount(code)
        }
      }
    },
    initPlatformExpanded() {
      let firstOpened = false
      this.platformsData.forEach((platform) => {
        const shouldOpen = !firstOpened && this.formData.platforms[platform.code] === 'Y'
        this.$set(this.platformExpanded, platform.code, shouldOpen)
        if (shouldOpen) {
          firstOpened = true
        }
      })
    },
    // 确认保存按钮
    async saveConfirm() {
      this.$refs['artistForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 相关信息的保存处理
    async formSubmit() {
      //只传允许修改的字段
      let msg = false
      const platformsAccountId = {}
      const platformsUid = {}
      for (const platformsKey in this.formData.platforms) {
        const rawIds = this.normalizeAccountList(this.formData.platforms_account_id[platformsKey])
        const rawUids = this.normalizeAccountList(this.formData.platforms_uid[platformsKey])
        const maxLength = Math.max(rawIds.length, rawUids.length)
        const ids = []
        const uids = []
        for (let index = 0; index < maxLength; index++) {
          const id = String(rawIds[index] || '').trim()
          const uid = String(rawUids[index] || '').trim()
          if (id || uid) {
            ids.push(id)
            uids.push(uid)
          }
          if (uid && !id) {
            msg = true
          }
        }
        platformsAccountId[platformsKey] = ids
        platformsUid[platformsKey] = uids
        if (this.formData.platforms[platformsKey] === 'Y' && ids.length === 0) {
          msg = true
        }
      }
      if (msg) {
        this.$message.error('平台开通,则平台ID必填')
        return false
      } else {
        const postData = {
          id: this.formData.id,
          platforms: this.formData.platforms,
          platforms_account_id: platformsAccountId,
          platforms_uid: platformsUid,
          kol_label: this.formData.kol_label,
          skin_type: this.formData.skin_type,
          live_type: this.formData.live_type,
          avatar: this.formData.avatar || null
        }
        const id = await this.$api.saveArtist(postData)
        if (id) {
          this.$notify.success('保存成功！')
          await this.initForm()
        }
        if (!this.artistId && id) {
          this.$router.push(this.$route.matched[1].path)
        }
      }


    },
    async getPlatforms() {
      // 获取最新平台信息
      const { list } = await this.$api.getPlatformAll({ status: 1 })
      this.platforms = list
      // 缓存平台信息
      localStorage.setItem('platforms', JSON.stringify(list))

    },
    showKolPlatformInfo(item) {
      this.platformDialogKey++
      if (item) {
        this.editForm = { ...item }
      } else {
        this.editForm = { ...data }
        this.editForm.artist_id = this.formData.id
      }
      this.dialogVisible = true
    },
    async delItem(item) {
      this.$confirm(`确认删除该条数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const id = await this.$api.delArtistPlatformInfo(item.id)
        if (id) {
          this.$message.success('删除成功~')
          await this.getKolPlatform()
        }
      })
    },
    async getKolPlatform() {
      const { list } = await this.$api.getKolJournalList({ artist_id: this.artistId })
      this.kolPlatform = list
    },
    // 同步红人基本信息（昵称/肤质/标签/直播类型）到全部刊例平台信息
    syncBasicInfo() {
      if (!this.formData.id) {
        this.$message.warning('请先保存红人基本信息后再同步')
        return
      }
      // 默认不覆盖已有字段，用户可勾选强制覆盖
      this.syncForceOverwrite = false
      this.syncDialogVisible = true
    },
    async confirmSyncBasic() {
      this.syncLoading = true
      try {
        const res = await this.$api.syncKolJournalBasic({
          artist_id: this.formData.id,
          nickname: this.formData.nickname,
          skin_type: this.formData.skin_type,
          kol_label: this.formData.kol_label,
          live_type: this.formData.live_type,
          force: this.syncForceOverwrite ? 1 : 0
        })
        if (res) {
          this.$message.success(`同步成功，共更新${res}条刊例平台信息`)
          await this.getKolPlatform()
        }
        this.syncDialogVisible = false
      } finally {
        this.syncLoading = false
      }
    },
    liveTypeName(val) {
      const found = this.liveTypeOptions.find(o => o.value === Number(val))
      return found ? found.name : '-'
    },
    handleLog() {
      this.LogdialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.artist-edit-page {
  min-height: calc(100vh - 96px);
  padding: 12px 28px 24px;
  background: #f4f5f7;
  box-sizing: border-box;
}

.artist-edit-grid {
  display: grid;
  grid-template-columns: minmax(330px, 1fr) minmax(360px, 1fr) minmax(360px, 1fr);
  gap: 28px;
  align-items: start;
}

.artist-edit-page > .artist-edit-form {
  padding: 0;
  background: transparent;
}

.artist-edit-panel {
  height: calc(100vh - 126px);
  min-height: 620px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 1px 5px rgba(31, 41, 55, .16);
}

.panel-header {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 20px;
  border-bottom: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #111827;
}

.panel-title strong {
  font-size: 16px;
}

.panel-title span {
  font-size: 12px;
  color: #7b8494;
}

.panel-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 18px 20px 22px;
  box-sizing: border-box;
}

.basic-profile {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 24px;
  border-bottom: 1px solid #dcdfe6;
}

.avatar-wrap {
  width: 104px;
  height: 104px;
  flex: 0 0 104px;
  overflow: hidden;
  border-radius: 50%;
}

.editable-avatar {
  position: relative;
  cursor: pointer;
}

.editable-avatar:hover {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.3);
}

.avatar-wrap .avatar-edit-badge {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: 26px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 12px;
  line-height: 26px;
  pointer-events: none;
}

.avatar-wrap ::v-deep .el-carousel {
  height: 104px;
}

.avatar-wrap ::v-deep .el-carousel__container {
  height: 104px !important;
}

.avatar-wrap ::v-deep .el-carousel__indicators {
  display: none;
}

.profile-info {
  min-width: 0;
}

.profile-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.profile-title-row h2 {
  max-width: 190px;
  margin: 0;
  overflow: hidden;
  color: #111827;
  font-size: 22px;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sign-status-pill {
  min-width: 68px;
  text-align: center;
  border: 0;
}

.sign-status-pill.is-signed {
  color: #16a56b;
  background: #dff6ea;
}

.sign-status-pill.is-fired {
  color: #ff3176;
  background: #fff0f6;
}

.readonly-field {
  min-height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  margin-top: 10px;
  background: #f6f7f9;
  border-radius: 8px;
  box-sizing: border-box;
}

.readonly-field span {
  color: #9aa3b2;
  font-size: 13px;
}

.readonly-field strong {
  color: #111827;
  font-size: 13px;
  line-height: 18px;
}

.edit-section-title {
  margin: 12px 0 8px;
  color: #8a93a3;
  font-weight: 600;
  font-size: 13px;
}

.platform-list,
.journal-list {
  padding: 12px 16px 18px;
}

.data-platform-card {
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #d8dce3;
  border-radius: 6px;
  background: #fff;
}

.data-platform-head {
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 12px;
  cursor: pointer;
}

.platform-name {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.platform-name strong,
.journal-platform-name strong {
  color: #111827;
  font-size: 15px;
}

.platform-name span {
  color: #6b7280;
  font-size: 12px;
}

.platform-icon {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.platform-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.platform-state-tag {
  border: 0;
}

.platform-state-tag.is-opened {
  color: #18a86c;
  background: #e6f8ef;
}

.platform-state-tag.is-closed {
  color: #9aa3b2;
  background: #f2f3f5;
}

.platform-arrow {
  color: #9aa3b2;
  font-size: 18px;
  cursor: pointer;
}

.account-editor {
  padding: 0 12px 12px;
}

.account-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 24px;
  gap: 16px;
  align-items: center;
  margin-bottom: 8px;
}

.remove-account {
  width: 24px;
  height: 24px;
  padding: 0;
  color: #c0c4cc;
  line-height: 24px;
  align-self: end;
  margin-bottom: 16px;
  text-align: center;
}

.remove-account:hover,
.remove-account:focus {
  color: #ff3176;
}

.add-account-button {
  width: 100%;
  height: 28px;
  color: #ff3176;
  background: #fff;
  border: 1px dashed #dcdfe6;
  cursor: pointer;
}

.journal-card {
  position: relative;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #d8dce3;
  border-radius: 6px;
  background: #fff;
}

.journal-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.journal-platform-name {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.journal-avatar {
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  overflow: hidden;
  border-radius: 50%;
}

.journal-info-line {
  overflow: hidden;
  color: #111827;
  font-size: 13px;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.journal-info-line span {
  color: #6b7280;
}

.journal-info-line.two-line {
  display: -webkit-box;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.journal-actions {
  display: flex;
  gap: 14px;
  margin-top: 8px;
}

.journal-actions ::v-deep .el-link.el-link--primary,
.panel-actions ::v-deep .el-link.el-link--primary {
  color: #ff3176;
}

.artist-edit-page ::v-deep .el-button--primary {
  background-color: #ff3176;
  border-color: #ff3176;
}

.artist-edit-page ::v-deep .el-button--primary:hover,
.artist-edit-page ::v-deep .el-button--primary:focus {
  background-color: #ff5c92;
  border-color: #ff5c92;
}

.artist-edit-page ::v-deep .el-form-item {
  margin-bottom: 12px;
}

.artist-edit-page ::v-deep .el-form-item__label {
  padding-bottom: 4px;
  color: #111827;
  font-weight: 500;
  line-height: 20px;
}

.artist-edit-page ::v-deep .el-form-item__content {
  min-width: 0;
  line-height: 28px;
}

.artist-edit-page ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.artist-edit-page ::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #ff3176;
  border-color: #ff3176;
}

.artist-edit-page ::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #ff3176;
}

@media (max-width: 1320px) {
  .artist-edit-grid {
    grid-template-columns: 1fr;
  }

  .artist-edit-panel {
    height: auto;
    min-height: 0;
  }
}

/* 同步基本信息弹窗 */
.sync-basic-body {
  padding: 4px 2px;
}

.sync-basic-desc {
  margin: 0 0 18px;
  color: #4a5468;
  font-size: 14px;
  line-height: 22px;
}

.sync-basic-desc strong {
  color: #ff3176;
}

.sync-basic-option {
  padding: 14px;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.sync-force-check {
  display: flex;
  height: 36px;
  line-height: 34px;
  font-weight: 600;
}

.sync-force-check ::v-deep .el-checkbox__label {
  color: #111827;
  font-size: 14px;
}

/* 勾选后的强效视觉反馈 */
.sync-force-check.is-checked ::v-deep .el-checkbox__inner {
  background-color: #ff3176;
  border-color: #ff3176;
}

.sync-force-check.is-checked ::v-deep .el-checkbox__label {
  color: #ff3176;
  font-weight: 700;
}

.sync-basic-mode {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0 0;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
}

.sync-basic-mode.is-fill {
  color: #18a86c;
  background: #e6f8ef;
}

.sync-basic-mode.is-overwrite {
  color: #ff3176;
  background: #ffeef4;
  font-weight: 600;
}
</style>

